import { CostAllocation, CustomCostAllocation, OrdinaryCostAllocation, ShareCostAllocation } from '@eadsysteme/billingclient-v1';

/**
 * Wire-Werte des dtype-Diskriminators einer CostAllocation.
 * Quelle: @DiscriminatorValue der Backend-Entities (billingws) — NICHT die Klassennamen.
 */
export enum CostAllocationDataType {
	SHARE = 'Share',
	ORDINARY = 'Ordinary',
	CUSTOM = 'Custom',
}

export function isShareAllocation(allocation: CostAllocation | null | undefined): allocation is ShareCostAllocation {
	return allocation?.dtype === CostAllocationDataType.SHARE;
}

export function isOrdinaryAllocation(allocation: CostAllocation | null | undefined): allocation is OrdinaryCostAllocation {
	return allocation?.dtype === CostAllocationDataType.ORDINARY;
}

export function isCustomAllocation(allocation: CostAllocation | null | undefined): allocation is CustomCostAllocation {
	return allocation?.dtype === CostAllocationDataType.CUSTOM;
}

/** Transloco-Key für das Typ-Label einer Umlage. */
export function getAllocationTypeLabelKey(dtype: string | undefined): string {
	switch (dtype) {
		case CostAllocationDataType.ORDINARY:
			return 'billing.dynamic';
		case CostAllocationDataType.CUSTOM:
			return 'billing.customAllocation';
		default:
			return 'billing.constant';
	}
}
